// extracted by mini-css-extract-plugin
export default {"activeButton":"ElevatorLevelSelectSvgs_activeButton__sljT5","borderPath":"ElevatorLevelSelectSvgs_borderPath__9FWv5","animation_glow":"ElevatorLevelSelectSvgs_animation_glow__3wS0r"};